// extracted by mini-css-extract-plugin
export var active = "_a1-7";
export var container = "_a1-0";
export var evenWidth = "_a1-4";
export var large = "_a1-5";
export var outlet = "_a1-8";
export var slide = "_a1-2";
export var small = "_a1-6";
export var tab = "_a1-3";
export var tabs = "_a1-1";